import React from "react"
import { SEO, Container, Text } from "@src/shared/components"
import { PageLayout } from "@src/features/marketing/components"
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Box,
  AccordionPanel,
  AccordionIcon,
  Heading as HeadingChakra,
} from "@chakra-ui/react"

const Page: React.FC = () => {
  return (
    <>
      <SEO robots="noindex, nofollow" />
      <PageLayout centerLogo simpleLayout>
        <Container>
          <Box maxW="2xl" margin="0 auto">
            <Box textAlign="center">
              <HeadingChakra fontSize="3xl" py={16}>
                Return Policy
              </HeadingChakra>
            </Box>

            <Text type="medium" mb={4}>
              We have a 30-day return policy, which means you have 30 days after
              receiving your item to request a return.
              <br />
            </Text>
            <Text type="medium" mb={4}>
              To be eligible for a return, your item must be in the same
              condition that you received it, unworn or unused, with tags, and
              in its original packaging. You’ll also need the receipt or proof
              of purchase.
            </Text>
            <Text type="medium" mb={4}>
              To start a return, you can contact us at ohema.eba@gmail.com.
              Please note that returns will need to be sent to the following
              address: 1190 Dundas Street, Suite 1101, Toronto ON M4M 0C5,
              Canada
            </Text>
            <Text type="medium" mb={4}>
              If your return is accepted, we’ll send you a return shipping
              label, as well as instructions on how and where to send your
              package. Items sent back to us without first requesting a return
              will not be accepted.
            </Text>

            <Text type="medium" mb={4}>
              You can always contact us for any return question at
              ohema.eba@gmail.com.
            </Text>

            <Accordion bg="#FFFCF7" mt={9} width="100%">
              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Damages and issues
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  Please inspect your order upon reception and contact us
                  immediately if the item is defective, damaged or if you
                  receive the wrong item, so that we can evaluate the issue and
                  make it right.
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Exceptions / non-returnable items
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    Certain types of items cannot be returned, like perishable
                    goods (such as food, flowers, or plants), custom products
                    (such as special orders or personalized items), and personal
                    care goods (such as beauty products). We also do not accept
                    returns for hazardous materials, flammable liquids, or
                    gases. Please get in touch if you have questions or concerns
                    about your specific item.
                    <br />
                    <br /> Unfortunately, we cannot accept returns on sale items
                    or gift cards.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Exchanges
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    The fastest way to ensure you get what you want is to return
                    the item you have, and once the return is accepted, make a
                    separate purchase for the new item.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        European Union 14 day cooling off period
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    Notwithstanding the above, if the merchandise is being
                    shipped into the European Union, you have the right to
                    cancel or return your order within 14 days, for any reason
                    and without a justification. As above, your item must be in
                    the same condition that you received it, unworn or unused,
                    with tags, and in its original packaging. You’ll also need
                    the receipt or proof of purchase.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Refunds
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    We will notify you once we’ve received and inspected your
                    return, and let you know if the refund was approved or not.
                    If approved, you’ll be automatically refunded on your
                    original payment method within 10 business days. Please
                    remember it can take some time for your bank or credit card
                    company to process and post the refund too. If more than 15
                    business days have passed since we’ve approved your return,
                    please contact us at ohema.eba@gmail.com.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Box>
        </Container>
      </PageLayout>
    </>
  )
}

export default Page
